import  types from "../actions/actionTypes";
import initialState from "./initialState";

const milestoneTemplateEntrysReducer = (state = initialState.milestoneTemplateEntrys, action) => {

    const mergeInMilestoneTemplateEntry = (milestoneTemplateEntrys, milestoneTemplateEntryUpdate) => {      
        if (milestoneTemplateEntryUpdate.id < 1) {
            return milestoneTemplateEntrys;
        }
        const milestoneTemplateEntrysMinusStaleData = milestoneTemplateEntrys.filter(milestoneTemplateEntry => milestoneTemplateEntry.id !== milestoneTemplateEntryUpdate.id);       
        return milestoneTemplateEntrysMinusStaleData.concat(milestoneTemplateEntryUpdate);
    }

     const deleteMilestoneTemplateEntry = (current, id) => {
        return current.filter(milestoneTemplateEntry => milestoneTemplateEntry.id !== id);
    } 


    switch (action.type) {
        case types.LOAD_MILESTONETEMPLATEENTRY_SUCCESS:
        case types.UPDATED_MILESTONETEMPLATEENTRY_SUCCESS:
            return mergeInMilestoneTemplateEntry(state, action.milestoneTemplateEntry);
            case types.DELETED_MILESTONETEMPLATEENTRY:      
            return deleteMilestoneTemplateEntry(state, action.milestoneTemplateEntry.id);      
        case types.DELETED_MILESTONETEMPLATEENTRY_INCOMING:  
        case types.UPDATED_MILESTONETEMPLATEENTRY_INCOMING:
            return deleteMilestoneTemplateEntry(state, action.payload.id);    
        default:
            return state;
    }
}

export default milestoneTemplateEntrysReducer;
